// Welcome Bonus — client hook (shared store: Header + Wallet + payout).

import { useCallback, useSyncExternalStore } from 'react';
import {
  claimSignupBonusShared,
  getSignupBonusSnapshot,
  loadSignupBonus,
  setSignupBonusClaimError,
  subscribeSignupBonus,
} from './signupBonusStore';

export function useSignupBonus() {
  const { bonus, loading, claiming, claimError } = useSyncExternalStore(
    subscribeSignupBonus,
    getSignupBonusSnapshot,
    getSignupBonusSnapshot
  );

  const claim = useCallback(async () => claimSignupBonusShared(), []);
  const setClaimError = useCallback((message: string | null) => {
    setSignupBonusClaimError(message);
  }, []);

  return {
    bonus,
    loading,
    claiming,
    claimError,
    setClaimError,
    claim,
    reload: () => loadSignupBonus(true),
  };
}
